import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import LatexPreview from "./LatexPreview";
import { Link} from "react-router-dom";
import {adjustStep, alignStrings, reverseStringResult} from "./helpers";
import { updateStatus } from "../../helpers/firebaseCRUD";

let depthArray = [];

function StepsRenderer({ data,correctAnswer }) {
  const [steps, setSteps] = useState([]);
  const [equation, setEquation] = useState();
  const [totalResponses, setTotalResponses] = useState();
  const [showPrevious, setShowPrevious] = useState(false);
  const [showNewExercise, setShowNewExercise] = useState(false);
  const [prevSteps, setPrevSteps] = useState([]);

  const stepCard = {
    display: "flex",
    margin: "30px 10px",
    borderRadius: "12px",
    padding: "10px",
    flexDirection: "column",
    height: "100%",
    width: "50%",
    cursor:"pointer",
    transition:'0.5s'
  };

  const stepsContainer = {
    "display":"flex",
    "flexDirection": "column",
    "overflow":"auto",
    "padding":"0px 16px",
    "justifyContent":"center",
    "alignItems": "center",
    "height": "60vh"
  };

  const handleCardClick = (key, isAnswer) => {
    if (!isAnswer) {
      depthArray.push(key);
      setShowPrevious(true);
      setShowNewExercise(isAnswer);
      const newPrevStep = [adjustStep(key)];
      setPrevSteps([...prevSteps, ...newPrevStep]);
      let obj = getChild(key);
      compileSteps(obj);
    }
  };

  const handleNewExercise = async () => {
    await updateStatus("WAITING_STUDENTS");
  };

  const handlePrevious = () => {
    if (depthArray.length) {
      depthArray.pop();
      let length = depthArray.length;
      let copyPrevSteps = [...prevSteps];
      copyPrevSteps.length = length > 0 ? length - 1 : 0;
      setPrevSteps(copyPrevSteps);
      let key = depthArray[length - 1];
      let obj = getChild(key);
      compileSteps(obj);

      if (!length) {
        setShowPrevious(false);
      }
    }
  };

  const getChild = (key) => {
    let currentSelection = data ? data.data : null;

    depthArray.forEach((v, i) => {
      if (currentSelection[v]) {
        currentSelection = currentSelection[v].steps;
      }
    });
    return currentSelection;
  };

  const compileSteps = (stepsObj) => {
    let st = [];
    if (stepsObj) {
      const uniqueSteps = new Map();
      st = Object.keys(stepsObj)
        .map((item) => {
          const splitItem = item.split("\\\\");
          let testItem =
            splitItem.length > 1
              ? splitItem[0] + "\\\\" + reverseStringResult(splitItem[1])
              : reverseStringResult(splitItem[0]);

          if (!uniqueSteps.has(testItem.toLowerCase())) {
            uniqueSteps.set(item, stepsObj[item].count);
            return {
              step: item,
              count: stepsObj[item].count,
              isAnswer: stepsObj[item].isAnswer,
            };
          } else {
            const count = uniqueSteps.get(testItem);
            uniqueSteps.set(testItem, count + 1);
          }
        })
        .filter(Boolean);

      st.forEach((value) => {
        value.count = uniqueSteps.get(value.step);
      });
      setSteps(st);
    }
  };

  const Card = ({ step, count, responses, isAnswer }) => {
    const subSteps = step.split(/\\\\+/);
    const actionRow =
      subSteps.length === 2
        ? /[A-Za-z]+/.test(subSteps[0])
          ? "\\" + subSteps[0].split("\\").filter(Boolean).join("\\quad\\")
          : subSteps[0].split("\\").filter(Boolean).join("\\quad\\")
        : null;
    const stepRow = subSteps.length === 2 ? subSteps[1] : subSteps[0];
    let correct = isAnswer
      ? isCorrectAnswer(correctAnswer, stepRow)
        ? "correct"
        : "wrong"
      : "";
    isAnswer ? setShowNewExercise(true) : setShowNewExercise(false);
    
    return (
      <div
        key={step}
        onClick={() => handleCardClick(step, isAnswer)}
        className="stepCard bg-light bg-light-hover"
        style={stepCard}
      >
        {actionRow && actionRow.length && actionRow.includes("\\") ? (
          <LatexPreview
            style={{
              flexGrow: "1",
              fontSize: "1.2em",
              alignItems: "center",
              display: "flex",
              alignSelf: "center",
            }}
            math={`${actionRow}`}
          />
        ) : (
          <pre
            style={{
              marginBottom: "0px",
              fontSize: "36px",
              fontWeight: "500",
            }}
          >
            {actionRow}
          </pre>
        )}
        {stepRow && stepRow.length && (
          <LatexPreview
            className={correct}
            style={{
              flexGrow: "1",
              fontSize: "1.2em",
              alignItems: "center",
              display: "flex",
              alignSelf: "center",
              margin: "0px",
            }}
            math={`\\${stepRow}`}
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "4px 6px",
            fontWeight: "500",
          }}
        >
          <span>{`${count}/${responses}`}</span>{" "}
          <span>{isAnswer ? "" : ">"}</span>
        </div>
      </div>
    );
  };

  const isCorrectAnswer = (correctAnswer, answer) => {
    var modifiedAnswer = answer.replace(/\s|\\|\(|\)/g, "");
    if (!correctAnswer) {
      return false;
    }

    const baseAnswer = alignStrings(correctAnswer);
    const inputAnswer = alignStrings(modifiedAnswer);

    if(inputAnswer === baseAnswer){
      return true;
    }

    //check if reverse answer match
    let splitAns = answer.split("=");

    if(splitAns.length === 2){
      let reverseAns = `${splitAns[1]}=${splitAns[0]}`;
      return reverseAns === baseAnswer;
    }

    return false;
  }

  const Steps = () => {
    let component = [];
    if (steps) {
      component = steps.map((v) => {
        let count = v.count;
        let step = v.step;
        let isAnswer = v.isAnswer;
        return (
          <Card
            count={count}
            responses={totalResponses}
            step={step}
            key={step}
            isAnswer={isAnswer}
          />
        );
      });
    }
    return component;
  };

  useEffect(() => {
    let st = data.data;
    setTotalResponses(data.total_responses);
    setEquation(data.startingEquation);
    compileSteps(st);
  }, []);

  return (
    <div
      style={{
        width: "86%",
        background: "white",
        color: "black",
        padding: "10px 0px",
        borderRadius: "20px",
        border: "4px solid gray",
        height:"86vh"
      }}
    >
      <div style={stepsContainer}>
        {equation && <LatexPreview className="math" math={equation} />}
        {prevSteps.length > 0 && (
          <div>
            {prevSteps.map((item, i) => (
              <div key={`${item}--${i}`}>
                {item[0] && item[0].includes("\\") ? (
                  <LatexPreview className="math" math={`${item[0]}`} />
                ) : (
                  <pre
                    style={{
                      margin: "10px",
                      fontSize: "36px",
                      fontWeight: "500",
                    }}
                  >
                    {item[0]}
                  </pre>
                )}
                {item[1] && (
                  <LatexPreview className="math" math={`\\${item[1]}`} />
                )}
              </div>
            ))}
          </div>
        )}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          {steps && Steps()}
        </div>
      </div>
      {showPrevious ? (
        <Button
          type="submit"
          variant="contained"
          size="large"
          className="CustomButton"
          onClick={handlePrevious}
          style={{ margin: "20px", marginBottom: "10px !important" }}
        >
          Previous Step
        </Button>
      ) : (
        ""
      )}
      {showNewExercise ? (
        <Link to="/instructor/write_exercise">
          <Button
            type="button"
            variant="contained"
            size="large"
            className="CustomButton"
            onClick={handleNewExercise}
            style={{ margin: "20px", marginBottom: "10px !important" }}
          >
            New Exercise
          </Button>
        </Link>
      ) : (
        ""
      )}
    </div>
  );
}

export default StepsRenderer;
